module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp3_7005.ff972e4b.png";